import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => ({
  noteLabel: {
    fontSize: 13
  },
  editNoteButton: {
    fontSize: 13,
    textDecoration: "underline",
    background: "transparent",
    textTransform: "none",
    justifyContent: "start",
    verticalAlign: "baseline",
    lineHeight: "inherit",
    padding: 0,
    "&.Mui-disabled": {
      color: theme.palette.text.disabled
    },
    "&:hover": {
      textDecoration: "underline",
      background: "transparent"
    }
  },
  details: {
    fontSize: 12
  },
  separator: {
    [theme.breakpoints.down(Breakpoints.SM_600)]: {
      display: "none"
    }
  },
  body: {
    fontSize: 12,
    padding: 0,
    margin: 0,
    wordBreak: "break-word"
  }
}));
